export default {
  mounted () {
    this.parentForm.$on('submit-request', this.validateAndShowUi)
    this.parentForm.$emit('field:added', this)
  },
  beforeDestroy () {
    // Remove any listeners from the bus
    this.parentForm.$off('submit-request', this.validateAndShowUi)
    this.parentForm.$emit('field:destroyed', this.name)
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/events.js